import { useAuth } from '@/contexts/AuthContext';
import { User } from '@/lib/api';

interface Permissions {
  isAdmin: boolean;
  isSuperAdmin: boolean;
  canManageUsers: boolean;
  hasRole: (role: User['role']) => boolean;
}

export function usePermissions(): Permissions {
  const { user } = useAuth();

  const isSuperAdmin = user?.role === 'super_admin';
  const isAdmin = user?.role === 'admin' || isSuperAdmin;
  const canManageUsers = isAdmin;

  return {
    isAdmin,
    isSuperAdmin,
    canManageUsers,
    hasRole: (role: User['role']) => user?.role === role,
  };
}
